import React from "react";
import HomeSettingTable from "./HomeSettingTable";
import { useDispatch, useSelector } from "react-redux";
import { showHomeSetting } from "../../../redux/actions";
import { responseSetting } from "../../../redux/reducers";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";

export default function HomeSetting() {
  const dispatch = useDispatch();
  const { homeSetting } = useSelector(responseSetting);

  const { user } = useAuth();
  const history = useHistory();

  React.useEffect(() => {
    if (user) {
      if (user.Queryable !== "queryable_special@123") {
        history.push("/home");
        return;
      }
    }
  }, [history, user]);

  React.useEffect(() => {
    dispatch(showHomeSetting());
  }, [dispatch]);

  return (
    <>
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>HomeSetting</div>
        </div>
        <div className={"breadcrumb-right"}>
          <span className={"breadcrumb-item active"}>HomeSetting</span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <HomeSettingTable dataSource={homeSetting} />
        </div>
      </div>
    </>
  );
}
